// extracted by mini-css-extract-plugin
export default {"container":"Scoreboard_container__1KGMX","turnIcon":"Scoreboard_turnIcon__CLqTC","BLUE":"Scoreboard_BLUE__5Mx30","RED":"Scoreboard_RED__OmqVF"};